import { useParams } from 'react-router-dom'

import { useVersioning } from 'modules/versioning'
import { getGroupFromURL } from '../utils'

import { RouteParams } from '@sketch/constants'

export const useGetIdentifiers = () => {
  const { shareID } = useParams<RouteParams<'SHARE_VIEW'>>()
  const group = getGroupFromURL()
  const { versionShortId, versionIdentifier } = useVersioning()

  return {
    shareIdentifier: shareID,
    versionShortId,
    versionIdentifier,
    group: group,
  }
}
